document.addEventListener('DOMContentLoaded', (e) => {
	const menu_form = document.querySelector('.m-menu__select');
	const changeSection = function (event) {
		const select = this.querySelector('#section');
		window.location = select.value;
	};
	if (menu_form) {
		menu_form.addEventListener('change', changeSection);
	}
});
